import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import BaseText from '@/components/BaseText.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import ShopifySetting from '@/plugins/graphql/queries/v2/app_shopify_setting.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let Shopify = class Shopify extends Mixins(RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.key = '';
    }
    visitShop(url) {
        window.open(`${url}/admin`, '_blank');
    }
};
Shopify = __decorate([
    Component({
        components: {
            ActionButton,
            BaseText,
            PageTitle,
        },
        apollo: {
            appShopifySetting: {
                query: ShopifySetting,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$data.key = to.name;
                return true;
            });
        },
        beforeRouteUpdate(to, from, next) {
            this.$data.key = to.name;
            next();
        },
    })
], Shopify);
export default Shopify;
